export const reorderUpdateDeleteChild = {
  props: {
    data: Object,
    last: Boolean,
    new: Boolean,
  },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    first() {
      return this.data.order === 0;
    },
  },
  methods: {
    move(direction) {
      this.$emit('change-order', {
        direction,
        index: this.data.order,
      });
    },
    askConfirmation() {
      this.showModal = true;
    },
    remove() {
      if (!this.new) {
        this.$emit('remove-item', this.data.order);
      } else {
        this.$emit('remove-new-item', this.data.order);
      }
      this.showModal = false;
    },
    update(e, key) {
      if (!this.new) {
        this.$emit('item-change', {
          value: e.target.value,
          key,
          index: this.data.order,
        });
      } else {
        this.$emit('new-item-change', {
          value: e.target.value,
          key,
          index: this.data.order,
        });
      }
      //this.$emit("item-change", { value: e.target.value, key, index: this.index });
    },
  },
};

import { mapActions, mapGetters } from 'vuex';
export const reorderUpdateDeleteParent = {
  methods: {
    ...mapActions([
      'fetchTiers',
      'addNewItem',
      'updateItem',
      'updateNewItem',
      'removeItem',
      'removeNewItem',
      'changeOrder',
    ]),
  },
  computed: {
    ...mapGetters(['items', 'newItems']),
    amount() {
      return this.items + this.items.length;
    },
  },
};
